export default __webpack_public_path__ + "static/media/folder-open.d37bc555.svg";